<app-header></app-header>
<app-sidebar></app-sidebar>
<main class="full-wrap">
    <div class="main-div">
        <div class="main-section">
            <div class="row main-row">
                <div class="col-md-12">
                    <div class="main-content">
                        <div class="page-heading col-md-12">
                            <div class="page-heading-name">
                                <img src="assets/images/icon/my_market.png"><span>My Market</span>
                            </div>
                        </div>
                        <div class="table-body">

                            <div class="tab-content" id="myTabContent">

                                <div class="tab-pane fade active show" id="mymarket">
                                    <ng-container *ngIf="popData == true">
                                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                                        <!--- Note that these columns can be defined in any order.
                                                  The actual rendered columns are set as a property on the row definition" -->

                                        <!-- Position Column -->
                                        <ng-container matColumnDef="number">
                                            <th mat-header-cell *matHeaderCellDef> S No</th>
                                            <td mat-cell *matCellDef="let element;let k = index;"> {{k+1}} </td>
                                            <td mat-footer-cell *matFooterCellDef> </td>
                                        </ng-container>

                                        <!-- Name Column -->
                                        <ng-container matColumnDef="sport_name">
                                            <th mat-header-cell *matHeaderCellDef> Sport Name </th>
                                            <td mat-cell *matCellDef="let element"> {{element.sport_name}} </td>
                                            <td mat-footer-cell *matFooterCellDef> </td>
                                        </ng-container>

                                        <!-- selection Column -->
                                        <ng-container matColumnDef="match_name">
                                            <th mat-header-cell *matHeaderCellDef> Match Name </th>
                                            <td mat-cell *matCellDef="let element" style="color: blue !important;cursor: pointer;" (click)="expoRoute(element)"> {{element.match_name}} </td>
                                            <td mat-footer-cell *matFooterCellDef> </td>
                                        </ng-container>

                                        <!-- sportName Column -->
                                        <ng-container matColumnDef="event_name">
                                            <th mat-header-cell *matHeaderCellDef> Market Name </th>
                                            <td mat-cell *matCellDef="let element"> {{element.event_name}} </td>
                                            <td mat-footer-cell *matFooterCellDef>Total </td>
                                        </ng-container>
                                        <ng-container matColumnDef="liability">
                                            <th mat-header-cell *matHeaderCellDef> Liability </th>
                                            <td mat-cell *matCellDef="let element"> <span
                                                    [ngClass]="{'error': element?.liability < 0 ,'success': element?.liability >= 0}">{{element?.liability
                                                    | number : '0.0-2'}}</span> </td>
                                            <td mat-footer-cell *matFooterCellDef> <span
                                                    [ngClass]="{'error':totalItems[0]?.liabilitySum < 0 ,'success': totalItems[0]?.liabilitySum >= 0}">{{totalItems[0]?.liabilitySum
                                                    | number : '0.0-2'}}</span>
                                        </ng-container>


                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;let k=index"></tr>
                                        <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
                                    </table>
                                </ng-container>
                                    <ng-container *ngIf="popData != true">{{message}}</ng-container>
                                    <!-- <div  style="float: right;width: 32%;margin:10px 0px;">
                                        <label style="width: 58%;">Total</label>
                                        <label style="width: 42%;" [ngClass]="{'error':exposureData[totalRecordIndex]?.liabilitySum < 0 ,'success': exposureData[totalRecordIndex]?.liabilitySum >= 0}">{{exposureData[totalRecordIndex]?.liabilitySum}}</label>
                                    </div> -->
                                    <!-- <div class="no-data-section row justify-content-center" *ngIf="dataSource?.length == 0">
                                    
                                        <img src="assets/icons/mood_bad_black.png">
                                        <h1>Game History</h1>
                                        <label>There is no data to display</label>
                                    </div>
                                    <mat-paginator  [ngClass]="{'hide':expoLength==0 ,'show':expoLength!=0}" [length]="totalItems" [pageSize]="50" #paginatorRef [pageIndex]="pageIndex"
                                    [pageSizeOptions]="[50, 100,150, 200]" aria-label="Select page" (page)="getExposureData($event)">
                                </mat-paginator> -->
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>

<app-footer-main></app-footer-main>